module.exports = __webpack_public_path__ + "static/img/GT@3x.712e04a6.png";